import { UserPermission } from 'data/__generated__';

export const EMPLOYEE = 'Employee';

export const TOTADMIN_PERMISSIONS = [UserPermission.Toteam, UserPermission.Totech, UserPermission.Totest];
